import '../stylesheets/active_admin'

import '@activeadmin/activeadmin'
import 'activeadmin_addons'

import 'chartkick/chart.js'

import '../src/masks'
import '../src/confirms'
import '../src/bordereau_modal'

const componentRequireContext = require.context('components', true)
const ReactRailsUJS = require('react_ujs')
ReactRailsUJS.useContext(componentRequireContext)
